import type { Dictionary } from '../i18n/dictionary';
import type { Story } from '../lib/story';
import { IconNavChartPie, IconNavFlag, IconNavWallet } from './icons';
import { Sidebar, type NavEntry } from './Sidebar';

const sample: Dictionary<{
  overview: string;
  wallets: string;
  goals: string;
  active: string;
  archived: string;
}> = {
  pl: {
    overview: 'Przegląd',
    wallets: 'Portfele',
    goals: 'Cele',
    active: 'Aktywne',
    archived: 'Archiwum',
  },
  en: {
    overview: 'Overview',
    wallets: 'Wallets',
    goals: 'Goals',
    active: 'Active',
    archived: 'Archived',
  },
};

// Every href lands on this page, so following one stays in the catalog; the
// first entry is the one lit, because it matches the current URL.
const HERE = '/library/sidebar';

export default {
  kind: 'component',
  title: { pl: 'Pasek boczny', en: 'Sidebar' },
  description: {
    pl: 'Nawigacja aplikacji z jednej tablicy `NavEntry`: pasek boczny od md, a poniżej dolny pasek z kartą na każdy wpis najwyższego poziomu. Grupa ma więc własne `href` i ikonę. Dolny pasek i siatkę `AppShellGrid` widać na żywo w samej Bibliotece — tutaj tylko pasek boczny, bo drugi dolny pasek przykryłby prawdziwy.',
    en: "An app's navigation from one `NavEntry` array: the side menu from md up, and below it a bottom bar with one tab per top-level entry. A group therefore needs its own `href` and icon. The bottom bar and the `AppShellGrid` around it are live in Library itself — this shows the side menu alone, since a second bottom bar would cover the real one.",
  },
  variants: [
    {
      name: { pl: 'Wpisy i grupa', en: 'Entries and a group' },
      render: (locale) => {
        const t = sample[locale];
        const items: NavEntry[] = [
          {
            key: 'overview',
            href: HERE,
            label: t.overview,
            icon: IconNavChartPie,
          },
          {
            key: 'wallets',
            href: `${HERE}#wallets`,
            label: t.wallets,
            icon: IconNavWallet,
          },
          {
            key: 'goals',
            href: `${HERE}#goals`,
            label: t.goals,
            icon: IconNavFlag,
            children: [
              { key: 'active', href: `${HERE}#active`, label: t.active },
              { key: 'archived', href: `${HERE}#archived`, label: t.archived },
            ],
          },
        ];
        return <Sidebar items={items} />;
      },
    },
  ],
} satisfies Story;
